<template>
	<div class="nav">
		<h1 class="title">alduin</h1>
		<CallToAction class="hideMobile" />
	</div>
</template>

<script>
import CallToAction from "./CallToAction.vue";

export default {
	components: { CallToAction },
};
</script>

<style scoped>
.nav {
	width: "100%";
	display: flex;
	justify-content: space-between;
	padding: 8px 16px;
}
.title {
	color: #3385ff;
	font-size: 40px;
	padding: 0;
	background: white;
	font-family: "Comfortaa-SemiBold";
	letter-spacing: 5px;
}
@media only screen and (max-width: 750px) {
	.title {
		font-size: 7vh;
	}
	.hideMobile {
		display: none;
	}
}
</style>
